import { useSelector } from "react-redux";
import { useTranslations } from "hooks";
import { NavbarSimple } from "fiver-react-ui-components";

const Wrapper = () => {
  const { walletBalance } = useSelector((s) => s.app);

  const { isLoggedIn } = useSelector((s) => s.auth);

  const [translations] = useTranslations();

  const navItems = [
    {
      text: translations.myPicks,
      icon: "emoji_events",
      to: "/",
      exact: true,
    },
    {
      text: translations.leaderboard,
      icon: "star",
      to: "/leaderboard",
      exact: true,
      // disabled: !isLoggedIn,
      //disabled: process.env.NODE_ENV !== "development",
    },
    {
      text: translations.wallet,
      icon: "euro",
      to: "/wallet",
      exact: true,
      //disabled: true,
      disabled: !walletBalance,
      //disabled: process.env.NODE_ENV !== "development" && !walletBalance,
      // disabled: process.env.NODE_ENV !== "development",
    },
    {
      text: translations.profile,
      icon: "account_circle",
      to: "/profile",
      exact: true,
      // disabled: !isLoggedIn,
    },
  ];

  return <NavbarSimple items={navItems} />;
};

export default Wrapper;
